/* Cadeau-actie (Kitesurfshop Haarlem)
   Twee soorten cadeau, elk max 1 per bestelling (verborgen regel-eigenschap _cadeau):
   - 'basis': niveau met "Altijd erbij" (bv. sticker vanaf 50), altijd naast het extra cadeau;
   - 'extra': 1 keuze uit de lijst van het hoogste behaalde extra niveau.
   - Klik op "Kies"/"Wissel": cadeau toevoegen; een eerder gekozen cadeau van dezelfde soort gaat eruit.
   - Na elke wijziging van het winkelmandje: cadeaus verwijderen die niet (meer) bij het behaalde niveau horen,
     en nooit meer dan 1 per soort. Cadeaubonnen tellen niet mee.
   Instellingen staan in snippets/cadeau-actie-config.liquid (uit de metaobjecten "Cadeau-actie"). */
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const isCadeau = (item) => Boolean(item.properties && item.properties._cadeau);
  const soortVan = (item) => (item.properties._cadeau === 'basis' ? 'basis' : 'extra');

  const leesConfig = () => {
    try {
      return JSON.parse(document.getElementById('cadeau-actie-config').textContent).acties || [];
    } catch (e) {
      return [];
    }
  };

  const post = (pad, body) =>
    fetch(root + pad, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then((res) => {
      if (!res.ok) throw res;
      return res.json();
    });

  const meldWijziging = () => {
    document.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false }));
  };

  let bezig = false;

  async function controleer() {
    if (bezig) return;
    bezig = true;
    let gewijzigd = false;
    try {
      const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const cadeauRegels = cart.items.filter(isCadeau);
      if (cadeauRegels.length) {
        const tegoed = cart.items
          .filter((i) => !isCadeau(i) && !i.gift_card)
          .reduce((som, i) => som + i.final_line_price, 0);
        const acties = leesConfig();
        const toegestaan = {};
        ['basis', 'extra'].forEach((soort) => {
          const beste = acties
            .filter((a) => Boolean(a.altijd) === (soort === 'basis') && tegoed >= a.drempel)
            .sort((a, b) => b.drempel - a.drempel)[0];
          toegestaan[soort] = new Set(beste ? beste.varianten : []);
        });

        const updates = {};
        const gehouden = { basis: false, extra: false };
        cadeauRegels.forEach((regel) => {
          const soort = soortVan(regel);
          if (!gehouden[soort] && toegestaan[soort].has(regel.variant_id)) {
            gehouden[soort] = true;
            if (regel.quantity !== 1) updates[regel.key] = 1;
          } else {
            updates[regel.key] = 0;
          }
        });

        if (Object.keys(updates).length) {
          await post('cart/update.js', { updates });
          gewijzigd = true;
        }
      }
    } catch (e) {
      console.warn('[cadeau-actie] controle mislukt', e);
    }
    bezig = false;
    if (gewijzigd) meldWijziging();
  }

  // Plaatje laten meewisselen met het gekozen ontwerp/variant
  document.addEventListener('change', (evt) => {
    const veld = evt.target.closest('select[data-cadeau-variant]');
    if (!veld) return;
    const optie = veld.options[veld.selectedIndex];
    const img = veld.closest('.cadeau-actie__optie').querySelector('[data-cadeau-img]');
    if (img && optie && optie.dataset.img) img.src = optie.dataset.img;
  });

  document.addEventListener('click', async (evt) => {
    const knop = evt.target.closest('[data-cadeau-kies]');
    if (!knop) return;
    evt.preventDefault();

    const veld = knop.closest('.cadeau-actie__optie').querySelector('[data-cadeau-variant]');
    const variantId = parseInt(veld && veld.value, 10);
    if (!variantId) return;
    const soort = knop.dataset.cadeauSlot === 'basis' ? 'basis' : 'extra';

    knop.disabled = true;
    bezig = true;
    try {
      const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const updates = {};
      cart.items
        .filter((regel) => isCadeau(regel) && soortVan(regel) === soort)
        .forEach((regel) => { updates[regel.key] = 0; });
      if (Object.keys(updates).length) await post('cart/update.js', { updates });

      await post('cart/add.js', {
        items: [{ id: variantId, quantity: 1, properties: { _cadeau: soort } }]
      });
    } catch (e) {
      console.warn('[cadeau-actie] toevoegen mislukt', e);
      knop.disabled = false;
    }
    bezig = false;
    meldWijziging();
  });

  document.addEventListener('theme:cartchanged', () => controleer());

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => controleer());
  } else {
    controleer();
  }
})();
